(function () {
  'use strict';

  // ---- Transparent header on scroll ----
  var header = document.querySelector('.site-header');
  if (header && header.classList.contains('transparent')) {
    var onScroll = function () {
      header.classList.toggle('scrolled', window.scrollY > 20);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ---- Mobile menu ----
  var burger = document.querySelector('.burger');
  var mobileMenu = document.querySelector('.mobile-menu');
  if (burger && mobileMenu) {
    burger.addEventListener('click', function () {
      var isOpen = mobileMenu.classList.toggle('open');
      burger.classList.toggle('open', isOpen);
      burger.setAttribute('aria-expanded', String(isOpen));
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });
    mobileMenu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        mobileMenu.classList.remove('open');
        burger.classList.remove('open');
        burger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });
    });
  }

  // ---- Product gallery thumbnails ----
  var mainImg = document.querySelector('.product-media .main-img img');
  var thumbs = document.querySelectorAll('.thumb-row button');
  if (mainImg && thumbs.length) {
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var full = btn.getAttribute('data-full');
        if (full) { mainImg.src = full; }
        thumbs.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
      });
    });
  }

  // ---- Quantity stepper ----
  document.querySelectorAll('.qty-control').forEach(function (ctrl) {
    var input = ctrl.querySelector('input');
    var minus = ctrl.querySelector('[data-qty="minus"]');
    var plus = ctrl.querySelector('[data-qty="plus"]');
    if (!input) return;
    if (minus) minus.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      if (v > 1) input.value = v - 1;
    });
    if (plus) plus.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
    });
  });

  // ---- Variant selection ----
  var variantForm = document.querySelector('[data-product-form]');
  if (variantForm) {
    var variantData = window.__slVariants || [];
    var selects = variantForm.querySelectorAll('[data-option-index]');
    var variantIdInput = variantForm.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-product-price]');
    var submitBtn = variantForm.querySelector('[type="submit"]');

    var updateVariant = function () {
      var chosen = [];
      selects.forEach(function (s) { chosen.push(s.value); });
      var match = variantData.find(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      });
      if (!match) return;
      if (variantIdInput) variantIdInput.value = match.id;
      if (priceEl) priceEl.innerHTML = match.price_html;
      if (submitBtn) {
        submitBtn.disabled = !match.available;
        submitBtn.textContent = match.available ? 'Add to bag' : 'Sold out';
      }
    };
    selects.forEach(function (s) { s.addEventListener('change', updateVariant); });
  }

  // ---- Marquee duplication for seamless loop ----
  var track = document.querySelector('.shelf-track');
  if (track && !track.dataset.duplicated) {
    track.innerHTML = track.innerHTML + track.innerHTML;
    track.dataset.duplicated = 'true';
  }
})();


// ---- Search panel + predictive results ----
(function () {
  var toggle = document.querySelector('.search-toggle');
  var panel = document.getElementById('searchPanel');
  if (!toggle || !panel) return;

  var input = panel.querySelector('.search-input');
  var closeBtn = panel.querySelector('.search-close');
  var results = document.getElementById('searchResults');

  function openSearch() {
    panel.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    setTimeout(function () { input && input.focus(); }, 40);
  }
  function closeSearch() {
    panel.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    if (results) { results.hidden = true; results.innerHTML = ''; }
  }

  toggle.addEventListener('click', function () {
    panel.hidden ? openSearch() : closeSearch();
  });
  if (closeBtn) closeBtn.addEventListener('click', closeSearch);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !panel.hidden) closeSearch();
  });

  // predictive search
  var timer = null;
  if (input && results) {
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { results.hidden = true; results.innerHTML = ''; return; }

      timer = setTimeout(function () {
        var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
                  '&resources[type]=product&resources[limit]=5';
        fetch(url)
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) {
              results.innerHTML = '<div class="sr-empty">No matches. Try another word.</div>';
              results.hidden = false;
              return;
            }
            var html = products.map(function (p) {
              var img = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
              return '<a href="' + p.url + '">' +
                (img ? '<img src="' + img + '" alt="" loading="lazy">' : '<img alt="">') +
                '<span><span class="sr-title">' + p.title + '</span>' +
                '<span class="sr-price">' + (p.price ? p.price : '') + '</span></span></a>';
            }).join('');
            html += '<a class="sr-all" href="/search?q=' + encodeURIComponent(q) + '&type=product">See all results &rarr;</a>';
            results.innerHTML = html;
            results.hidden = false;
          })
          .catch(function () {
            // predictive search unavailable — the form still submits normally
            results.hidden = true;
          });
      }, 220);
    });
  }
})();
